import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@shared/services/auth.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();

  const isAuthEndpoint = req.url.includes('/auth/login') || req.url.includes('/auth/refresh');
  // Solo adjuntar el token a la API propia (URL relativa o environment.apiUrl), nunca a hosts de terceros.
  const isOwnApi = !/^[a-z][a-z0-9+.-]*:\/\/|^\/\//i.test(req.url) || req.url.startsWith(environment.apiUrl);
  if (token && !isAuthEndpoint && isOwnApi) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req);
};
